/**
 * @docs docs/features/product-domain-listings
 */

import { definePageRoute } from '@common/router/definitions';

import { buildDomainsLandingRouteData, renderDomainsLandingRoute } from './lib/route';

// Keep reserved sub-routes from falling through to the generic slug landing page.
export default definePageRoute({
    path: '/domains/:slug((?!tlds$|tld$|sector$)[^/]+)',
    options: { auth: false, layout: false },
    data: buildDomainsLandingRouteData,
    render: renderDomainsLandingRoute,
});
